export default __webpack_public_path__ + "static/media/cyber-santa-homepage.74d878e2.png";